<template>
	<div class="wrap">
		<!-- 面包屑导航区 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item class="test">加入我们 设置</el-breadcrumb-item>
		</el-breadcrumb>

		<el-card >

			<!-- 表格数据 -->
			<h3>招聘岗位修改：</h3>
			<el-table :data="zhaopinList" border :strip="true">
				<el-table-column label="ID" width="70px" prop="id"></el-table-column><!-- type="index" -->
				<el-table-column label="岗位类型" prop="jobName"></el-table-column>
				<el-table-column label="职位" prop="positionName">
					<!-- <template slot-scope="scope">
						<img :src="$imgTitle+scope.row.coverPicture" style="width: 150px;height: 150px;" />
					</template> -->
				</el-table-column>
				<el-table-column label="部门" prop="departmentName"></el-table-column>
				<el-table-column label="地址" prop="address"></el-table-column>
				<el-table-column label="权重" prop="weights"></el-table-column>
				<el-table-column label="添加时间" prop="createTime">
					<template slot-scope="scope">{{scope.row.createTime | dataFormat }}</template>
				</el-table-column>

				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button type="primary" @click="gotoEdit(scope.row.id)">编辑</el-button>
						<el-button type="danger" @click="delJob(scope.row.id)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>

			<el-button class="addBtn" type="success" @click="addZhaopin" style="margin-top: 20px;">添加招聘信息</el-button>

			
		</el-card>
		
		<el-card style="margin-top: 40px;">
			<!-- 表格数据 -->
			<h3>办公环境 修改：</h3>
			<el-table :data="huajingList" border :strip="true">
				<!-- <el-table-column label="ID" width="70px" prop="id"></el-table-column> --><!-- type="index" -->
				<!-- <el-table-column label="环境图片" prop="jobName"></el-table-column> -->
				<el-table-column label="办公环境图片" prop="positionName" width="200px">
					<template slot-scope="scope">
						<img :src="$imgTitle+scope.row.url" style="width: 150px;height: 150px;" />
					</template>
				</el-table-column>
				<!-- <el-table-column label="部门" prop="departmentName"></el-table-column>
				<el-table-column label="地址" prop="address"></el-table-column> -->
				<!-- <el-table-column label="权重" prop="weights"></el-table-column> -->
				<!-- <el-table-column label="添加时间" prop="createTime">
					<template slot-scope="scope">{{scope.row.createTime | dataFormat }}</template>
				</el-table-column> -->
		
				<el-table-column label="操作">
					<template slot-scope="scope">
						 <el-button type="primary" @click="gotoEdit2(scope.row.idx)">编辑</el-button>
						<!--<el-button type="danger" @click="delJob(scope.row.id)">删除</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			
			<el-tag type="danger" style="margin-left: 20px;margin-top: 20px;">加入我们 页面如需其他修改，请联系前端修改</el-tag>
			<!-- <el-button class="addBtn" type="success" @click="addZhaopin" style="margin-top: 20px;">添加办公环境图片</el-button> -->
		
			<!-- <el-tag type="danger" style="margin-left: 20px;margin-top: 20px;">加入我们 页面如需其他修改，请联系前端修改</el-tag> -->
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				zhaopinList: [],
				huajingList: []
			}
		},
		created() {
			this.getZhaopinList()
			this.getHuangjingList()
			var list = {
				"data": {
					"code": 0,
					"message": "success.",
					"data": {
						"pageNo": 1,
						"totalNum": 4,
						"totalPage": 1,
						"list": [{
							"id": 4,
							"createTime": 1592293264000,
							"updateTime": 1592293266000,
							"jobType": "1",
							"jobName": "平面包装设计",
							"positionType": "1",
							"positionName": "设计",
							"departmentType": "1",
							"departmentName": "设计部",
							"address": "广东广州",
							"content": "<p>\r\n    <span style=\"font-size: 16px; background-color: rgb(146, 205, 220); --darkreader-inline-bgcolor:#8bb6bd;\"><strong><span style=\"font-size: 16px; background-color: rgb(146, 205, 220); font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; --darkreader-inline-bgcolor:#8bb6bd;\">01岗位职责</span></strong></span><span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\"><br/></span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">1、负责公司各个渠道的整体形象设计、商品展示设计、详情页优化、整体布局、活动推广等；</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">2、根据每月制定的促销计划、活动策划，设计相关广告logo、banner、海报并对效果进行跟踪；</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">3、负责公司对外宣传物料设计、节日海报设计、产品包装设计；</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">4、完成上级领导安排的其他工作。</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\"><br/></span>\r\n</p>\r\n<p>\r\n    <span style=\"background-color: rgb(146, 205, 220); --darkreader-inline-bgcolor:#8bb6bd;\"><strong><span style=\"background-color: rgb(146, 205, 220); font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 16px; --darkreader-inline-bgcolor:#8bb6bd;\">02任职要求</span></strong></span><span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\"><br/></span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">1、熟练掌握PS、AI、CDR等相关设计软件操作；</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\"><span style=\"font-family: 宋体;\">2、有2年以上平面设计经验，有较强的视觉效果功底，美术、设计、广告等相关专业，新手不考虑</span><span style=\"color: rgb(38, 43, 51); background: rgb(255, 255, 255) none repeat scroll 0% 0%; font-family: 宋体; --darkreader-inline-color:#353737; --darkreader-inline-bgcolor:#e1dcd2; --darkreader-inline-bgimage:none;\">；</span></span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\"><span style=\"color: rgb(38, 43, 51); background: rgb(255, 255, 255) none repeat scroll 0% 0%; font-family: 宋体; --darkreader-inline-color:#353737; --darkreader-inline-bgcolor:#e1dcd2; --darkreader-inline-bgimage:none;\"><br/></span></span>\r\n</p>\r\n<p>\r\n    <img src=\"http://group.jiuhangjituan.cn/activityNewInfo/202006161547325582553.jpg\" title=\"activityNewInfo/202006161547325582553.jpg\" alt=\"微信图片_20200615163808.jpg\"/>\r\n</p>",
							"weights": 4
						}, {
							"id": 3,
							"createTime": 1592292250000,
							"updateTime": 1592292253000,
							"jobType": "1",
							"jobName": "短视频演员",
							"positionType": "1",
							"positionName": "新媒体",
							"departmentType": "1",
							"departmentName": "项目部",
							"address": "广东广州",
							"content": "<p>\r\n    <strong><span style=\"background-color: rgb(146, 205, 220); --darkreader-inline-bgcolor:#8bb6bd;\"><span style=\"background-color: rgb(146, 205, 220); font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 16px; --darkreader-inline-bgcolor:#8bb6bd;\">01岗位职责</span></span></strong>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\"><br/></span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">1、负责抖音短视频等内容出镜表演，可以在网络平台直播等；</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">2、有才艺，如能歌善舞，会化妆加分；</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\"><br/></span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\"></span>\r\n</p>\r\n<p>\r\n    <span style=\"background-color: rgb(146, 205, 220); --darkreader-inline-bgcolor:#8bb6bd;\"><strong><span style=\"background-color: rgb(146, 205, 220); font-family: 宋体; font-size: 16px; --darkreader-inline-bgcolor:#8bb6bd;\">02任职要求</span></strong></span><span style=\"font-family: 宋体; font-size: 14px;\"><br/></span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">1、18岁-28岁，普通话标准，性格开朗，颜值高，气质佳，有亲和力，有责任心；</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">2、擅长或者有意愿参加表演工作；</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">3、有点才艺，比如唱歌、舞蹈；</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">4、有无经验均可，公司有优秀的指导老师，一对一培训。</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\"><br/></span>\r\n</p>\r\n<p>\r\n    <img src=\"http://group.jiuhangjituan.cn/activityNewInfo/202006161525081184189.jpg\" title=\"activityNewInfo/202006161525081184189.jpg\" alt=\"微信图片_20200615163607.jpg\"/><span style=\";font-family:宋体;font-size:16px\"></span><br/>\r\n</p>\r\n<p>\r\n    <span style=\";font-family:宋体;font-size:16px\"><br/></span>\r\n</p>\r\n<p>\r\n    <br/>\r\n</p>",
							"weights": 3
						}, {
							"id": 2,
							"createTime": 1590714441000,
							"updateTime": 1590714441000,
							"jobType": "1",
							"jobName": "化妆品线下销售",
							"positionType": "1",
							"positionName": "销售",
							"departmentType": "1",
							"departmentName": "销售部",
							"address": "广东广州",
							"content": "<p>\r\n    <span style=\"background-color: rgb(146, 205, 220); --darkreader-inline-bgcolor:#8bb6bd;\"><strong><span style=\"background-color: rgb(146, 205, 220); font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 16px; --darkreader-inline-bgcolor:#8bb6bd;\">01岗位职责</span></strong></span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">1、负责协助经销商向意向加盟代理门店沟通介绍项目优势，解决异议，完成签约；</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">2、与各地区经销商一起以地推形式，向下游门店介绍公司模式和产品，争取下单，做代理；</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">3、能适应长期出差。</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\"><br/></span>\r\n</p>\r\n<p>\r\n    <span style=\"background-color: rgb(146, 205, 220); --darkreader-inline-bgcolor:#8bb6bd;\"><strong><span style=\"background-color: rgb(146, 205, 220); font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 16px; --darkreader-inline-bgcolor:#8bb6bd;\">02任职要求</span></strong></span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">1、有一年以上地推销售经验，可独立对接地区代理商</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">2、具有客户服务意识和商务谈判及电话沟通技巧</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">3、性格开朗活泼，大胆，沟通能力强，热情</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">4、能接受出差，有团队意识，服从领导安排</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">5、有极强的责任感、忠诚度和上进心</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\"><br/></span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\"><img src=\"http://group.jiuhangjituan.cn/activityNewInfo/202006161522409141834.jpg\" title=\"activityNewInfo/202006161522409141834.jpg\" alt=\"微信图片_20200615163351.jpg\"/></span>\r\n</p>\r\n<p>\r\n    <span style=\";font-family:宋体;font-size:16px\"><br/></span><br/>\r\n</p>\r\n<p>\r\n    <br/>\r\n</p>",
							"weights": 2
						}, {
							"id": 1,
							"createTime": 1590714441000,
							"updateTime": 1590714441000,
							"jobType": "1",
							"jobName": "化妆品线上销售",
							"positionType": "1",
							"positionName": "销售",
							"departmentType": "1",
							"departmentName": "销售部",
							"address": "广东广州",
							"content": "<p style=\"text-align: left;\">\r\n    <span style=\"--darkreader-inline-border-top:currentcolor; --darkreader-inline-border-right:currentcolor; --darkreader-inline-border-bottom:currentcolor; --darkreader-inline-border-left:currentcolor; border: medium none; font-size: 16px; --darkreader-inline-bgcolor:#8bb6bd; background-color: rgb(146, 205, 220);\"><strong><span style=\"font-size: 16px; background-color: rgb(146, 205, 220); border: medium none; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; --darkreader-inline-border-top:currentcolor; --darkreader-inline-border-right:currentcolor; --darkreader-inline-border-bottom:currentcolor; --darkreader-inline-border-left:currentcolor; --darkreader-inline-bgcolor:#8bb6bd;\">01岗位职责</span></strong></span><span style=\"background-color: rgb(195, 214, 155); --darkreader-inline-bgcolor:#b4c08e;\"><span style=\"--darkreader-inline-border-top:currentcolor; --darkreader-inline-border-right:currentcolor; --darkreader-inline-border-bottom:currentcolor; --darkreader-inline-border-left:currentcolor; border: medium none; --darkreader-inline-bgcolor:#c4beb3; font-size: 16px;\"><strong><span style=\"border: medium none; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; --darkreader-inline-border-top:currentcolor; --darkreader-inline-border-right:currentcolor; --darkreader-inline-border-bottom:currentcolor; --darkreader-inline-border-left:currentcolor; --darkreader-inline-bgcolor:#c4beb3;\"></span></strong></span><span style=\"--darkreader-inline-bgcolor:#c4beb3;\"><span style=\"background-color: rgb(195, 214, 155); --darkreader-inline-border-top:currentcolor; --darkreader-inline-border-right:currentcolor; --darkreader-inline-border-bottom:currentcolor; --darkreader-inline-border-left:currentcolor; border: medium none; --darkreader-inline-bgcolor:#b4c08e;\"><strong><span style=\"background-color: rgb(195, 214, 155); border: medium none; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px; --darkreader-inline-border-top:currentcolor; --darkreader-inline-border-right:currentcolor; --darkreader-inline-border-bottom:currentcolor; --darkreader-inline-border-left:currentcolor; --darkreader-inline-bgcolor:#b4c08e;\"></span></strong></span><span style=\"--darkreader-inline-border-top:currentcolor; --darkreader-inline-border-right:currentcolor; --darkreader-inline-border-bottom:currentcolor; --darkreader-inline-border-left:currentcolor; border: medium none; --darkreader-inline-bgcolor:#c4beb3;\"><strong><span style=\"border: medium none; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px; --darkreader-inline-border-top:currentcolor; --darkreader-inline-border-right:currentcolor; --darkreader-inline-border-bottom:currentcolor; --darkreader-inline-border-left:currentcolor; --darkreader-inline-bgcolor:#c4beb3;\"></span></strong><span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px; --darkreader-inline-bgcolor:#c4beb3;\"></span></span></span></span>\r\n</p>\r\n<p style=\"text-align: left;\">\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">1、顾问式销售，通过打电话等网络工具和出差的形式负责维护经销商和门店的客户关系，与客户保持日常沟通，做好售后维护，促成老客户二次销售和多次复购，达成销售业绩指标；</span>\r\n</p>\r\n<p style=\"text-align: left;\">\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">2、挖掘客户的潜力，为客户提供全方位的市场业务咨询服务（公司提供专业培训）；</span>\r\n</p>\r\n<p style=\"text-align: left;\">\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">3、依据客户的订单需求，负责更新销售管理系统的销售清单信息，完整地和相关部门对接客户订货数量、发货时间等信息，跨部门配合，保障客户的极致体验；</span>\r\n</p>\r\n<p style=\"text-align: left;\">\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">4、配合完成公司举办的市场推广活动、新品推广活动；</span>\r\n</p>\r\n<p style=\"text-align: left;\">\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">5、负责个人销售管理系统中的客户的辅导，对客户的活跃度、返单，复购和门店升级等核心指标负责。</span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\"><br/></span>\r\n</p>\r\n<p style=\"text-align: left;\">\r\n    <span style=\"font-size: 16px; background-color: rgb(146, 205, 220); --darkreader-inline-bgcolor:#8bb6bd;\"><strong><span style=\"font-size: 16px; background-color: rgb(146, 205, 220); font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; --darkreader-inline-bgcolor:#8bb6bd;\">02任职要求</span></strong></span>\r\n</p>\r\n<p style=\"text-align: left;\">\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">1、高中以上学历，2年以上销售经验，有产品销售如日化产品或保险，B2B销售、大客户销售相关的工作经验者优先；</span>\r\n</p>\r\n<p style=\"text-align: left;\">\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">2、熟练掌握2种以上客户谈判成交技巧，主动性强、勤奋耐劳，有非常强烈的进取心和目标感；</span>\r\n</p>\r\n<p style=\"text-align: left;\">\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">3、对销售流程中的各类销售数据有较强的分析能力，通过数据分析能发现数据背后的问题，提升销售业绩；</span>\r\n</p>\r\n<p style=\"text-align: left;\">\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">4、知识结构较全面，能够迅速掌握与公司业务有关的各种知识，可迅速适应全新的行业领域及业务模式，对互联网电商，数字化新零售，大日化或快消品行业感兴趣；</span>\r\n</p>\r\n<p style=\"text-align: left;\">\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">5、有较强的逻辑推演，协调、沟通能力及人际交往能力，敏锐的洞察力，有较强的判断与决策能力，计划和执行能力，应变和解决问题的能力，有服务意识，开拓精神和团队精神；</span>\r\n</p>\r\n<p style=\"text-align: left;\">\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">6、工作细致负责，认真努力踏实肯干，学习能力强，适应能力强，善于表达自己的观点和吸纳他人的建议；</span>\r\n</p>\r\n<p style=\"text-align: left;\">\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">7、人品端正，职业化素养高，热爱销售工作，认同公司文化和价值观，抗压性强，喜欢挑战性工作，可接受短期出差。</span>\r\n</p>\r\n<p style=\"text-align: left;\">\r\n    <span style=\"font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; font-size: 14px;\">8、公司提供培训，需通过全部专业考核方可正式上岗。</span>\r\n</p>\r\n<p>\r\n    <span style=\";font-family:宋体;font-size:16px\"><img src=\"http://group.jiuhangjituan.cn/activityNewInfo/202006161517323616691.jpg\" title=\"activityNewInfo/202006161517323616691.jpg\" alt=\"微信图片_20200615163002.jpg\"/></span>\r\n</p>\r\n<p>\r\n    <span style=\"font-family: 宋体;\"><br/></span><br/>\r\n</p>\r\n<p>\r\n    <br/>\r\n</p>",
							"weights": 1
						}]
					}
				},
				"status": 200,
				"statusText": "",
				"headers": {
					"access-control-allow-origin": "*",
					"date": "Thu, 02 Jul 2020 03:19:34 GMT",
					"vary": "Origin, Access-Control-Request-Method, Access-Control-Request-Headers",
					"transfer-encoding": "chunked",
					"content-type": "application/json;charset=UTF-8"
				},
				"config": {
					"url": "/v1/official/manag/recruitment/job/list",
					"method": "post",
					"data": "{\"request\":{}}",
					"headers": {
						"Accept": "application/json, text/plain, */*",
						"Content-Type": "application/json;charset=utf-8",
						"Authorization": "1:52F5CC6821537C8D9FCA31E8B3EB9BD3A3E18B94CA015773"
					},
					"baseURL": "http://xhm.jiuhuakang.com",
					"transformRequest": [null],
					"transformResponse": [null],
					"timeout": 0,
					"xsrfCookieName": "XSRF-TOKEN",
					"xsrfHeaderName": "X-XSRF-TOKEN",
					"maxContentLength": -1
				},
				"request": {}
			}
		},
		methods: {
			async getZhaopinList() {
				var res = await this.$http.post('/v1/official/manag/recruitment/job/list', {
					request: {

					}
				})

				console.log(JSON.stringify(res))
				if (res.data.code == 0) {
					this.zhaopinList = res.data.data.list
				}

			},
			async getHuangjingList() {
				/* 6.办公环境列表/v1/official/manag/environment/list  get请求 无参 也无需传request。 */
				var res = await this.$http.get('/v1/official/manag/environment/list', {
					params: {

					}
				})
				var data = {
					"data": {
						"code": 0,
						"message": "success.",
						"data": {
							"pageNo": 1,
							"totalNum": 1,
							"totalPage": 1,
							"list": [{
								"id": 1,
								"createTime": 1591930275000,
								"updateTime": 1591930335000,
								"picture1": "%E5%8A%9E%E5%85%AC%E5%AE%A4.jpg",
								"picture2": "%E8%8C%B6%E5%AE%A42.jpg",
								"picture3": "%E4%BC%9A%E8%AE%AE%E5%AE%A42.jpg",
								"picture4": "%E8%AF%81%E4%B9%A6%E8%8D%A3%E8%AA%89%E5%A2%99.JPG",
								"picture5": "%E8%B5%B0%E5%BB%8A.JPG",
								"picture6": "1"
							}]
						}
					},
					"status": 200,
					"statusText": "",
					"headers": {
						"date": "Thu, 02 Jul 2020 06:36:40 GMT",
						"transfer-encoding": "chunked",
						"content-type": "application/json;charset=UTF-8"
					},
					"config": {
						"url": "/v1/official/manag/environment/list",
						"method": "get",
						"params": {},
						"headers": {
							"Accept": "application/json, text/plain, */*",
							"Authorization": "1:52F5CC6821537C8D9FCA31E8B3EB9BD3A3E18B94CA015773"
						},
						"baseURL": "http://xhm.jiuhuakang.com",
						"transformRequest": [null],
						"transformResponse": [null],
						"timeout": 0,
						"xsrfCookieName": "XSRF-TOKEN",
						"xsrfHeaderName": "X-XSRF-TOKEN",
						"maxContentLength": -1
					},
					"request": {}
				}
				console.log('办公环境=' + JSON.stringify(res))
				if(res.data.code == 0){
					var obj = res.data.data.list[0];
					this.huajingList= [{url:obj.picture1,idx:0},{url:obj.picture2,idx:1},{url:obj.picture3,idx:2},{url:obj.picture4,idx:3},{url:obj.picture5,idx:4}];
					
				}
			},
			gotoEdit(id) {
				console.log(id)
				this.$router.push({
					path: '/editjob',
					query: {
						id: id
					}
				})
			},
			gotoEdit2(index){
				console.log(index)
				this.$router.push({
					path:'/edithuanjingtupian',
					query:{
						index:index
					}
				})
			},
			async delJob(id) {
				/* 5.在招岗位删除/v1/official/manag/deleteRecruitmentJob get 请求 参数  Long id */
				console.log(id)
				const confirmResult = await this.$confirm(
					'此操作将删除该招聘岗位, 是否继续?',
					'提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}
				).catch(err => err)
				if (confirmResult !== 'confirm') {
					return this.$message.info('已取消删除！')
				}
				var res = await this.$http.get('/v1/official/manag/deleteRecruitmentJob', {
					params: {
						id: id
					}
				})
				console.log(JSON.stringify(res))
				if (res.data.code == 0) {
					this.$message.success('删除成功')
					this.getZhaopinList();
				} else {
					this.$message.success(res.data.message)
				}

			},
			addZhaopin() {
				this.$router.push({
					path: '/addjob'
				})
			}
		}
	}
</script>

<style lang="less" scoped>

</style>
